import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=5cb51510&lang=html"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
import style0 from "../../assets/vendors/kendoui/kendo.common.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../assets/vendors/kendoui/kendo.default.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../../assets/vendors/kendoui/kendo.default.mobile.min.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports